import { Pen, Palette, MessageSquare, LineChart, Computer, Settings, Bot } from 'lucide-react';

export const ROLES = {
    DESIGNER: {
        icon: Palette,
        title: "Visual Designer Sidekick",
        subtitle: "Specialized in graphics, presentations, and marketing materials",
        defaultPrompt: "What kind of design would you like me to create?",
        actions: [
            "Create a Logo",
            "Design Visual for Social Media",
            "Create a Banner"
        ],
        color: "blue"
    },
    WRITER: {
        icon: Pen,
        title: "Content Writer Sidekick",
        subtitle: "Expert in creating engaging written content",
        defaultPrompt: "What would you like me to write?",
        actions: [
            "Write a Blog Post",
            "Create Social Copy",
            "Draft Email Campaign"
        ],
        color: "purple"
    },

    PFM: {
        icon: Computer,
        title: "Paid Ads Sidekick",
        subtitle: "Specialist in Designing and Executing High-Performance Ad Campaigns",
        defaultPrompt: "What would you like me to help your paid campaign strategy?",
        actions: [
          "Create Copy for SEM",
          "Create Copy for Meta Ads",
          "Create Paid Campaign Structure",
          "Generate Visual Headline ans Subheadline for Paid Ads"
        ],
        color: "green"
      },
      DATAANALYST: {
        icon: LineChart,
        title: "Data Analyst Sidekick",
        subtitle: "Transform your data into actionable insights",
        defaultPrompt: "What data analysis would you like me to perform?",
        actions: [
          "Analyze Trends",
          "Create Reporting Format",
        ],
        color: "orange"
      },
      ASSISTANT: {
        icon: MessageSquare,
        title: "Virtual Assistant Sidekick",
        subtitle: "Your all-purpose productivity companion",
        defaultPrompt: "How can I assist you today?",
        actions: [
          "Research Topics",
          "Summarize Content"
        ],
        color: "red"
      },
      BUSINESSANALYST: {
        icon: Settings,
        title: "Business Analyst Sidekick",
        subtitle: "Strategic guidance for your business needs",
        defaultPrompt: "What business challenge can I help with?",
        actions: [
          "Strategic Planning",
          "Market Analysis",
          "Risk Assessment"
        ],
        color: "indigo"
      }
};

// Color mapping for different roles
export const COLOR_VARIANTS = {
    blue: "bg-blue-600 hover:bg-blue-700",
    purple: "bg-purple-600 hover:bg-purple-700",
    green: "bg-green-600 hover:bg-green-700",
    orange: "bg-orange-600 hover:bg-orange-700",
    red: "bg-red-600 hover:bg-red-700",
    indigo: "bg-indigo-600 hover:bg-indigo-700",
    custom: "bg-gray-600 hover:bg-gray-700"
};